import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4059" />
      <ArchitectureDiagram data-id="element-4060" />
      <HowItWorksConnections mode="how" data-id="element-4061" />
      <LivesInSlack data-id="element-4062" />
      <ComputerUse data-id="element-4063" />
      <CapabilityGrid data-id="element-4064" />
      <NarrativeSection data-id="element-4065" />
      <ToolComparison data-id="element-4066" />
      <WallOfLove data-id="element-4067" />
      <PricingSection data-id="element-4068" />
      <ClosingCTA data-id="element-4069" />
    </>;
}